import React, { useState, useEffect, useRef } from "react";
import "./dynamicTable.css";
import dayjs from "dayjs";
import { convertCase } from "../Helper/utils";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useTranslation } from "react-i18next";
import { useQRModal } from "../../../Context/QrContext";
import { showDeleteConfirmation } from "../WarningMessage/deleteWarning";

const DynamicTable = ({
  header,
  tablebody,
  setTableBody,
  onEdit,
  page,
  onDelete,
  groupedDataSorted,
  onPrint,
  pageName,
}) => {
  const { printedRowss, PrintLabel, setPrintedRows } = useQRModal();
  console.log("pageName", pageName);

  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      if (openDropdownIndex !== null && !event.target.closest(".dropdown")) {
        setOpenDropdownIndex(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openDropdownIndex]);

  if (!header || header.length === 0) {
    return (
      <div className="d-flex justify-content-center">No data available</div>
    ); // Display a message if no data is passed
  }

  // const formattedHeaders = [...header].map(header => t(convertCase(header)));
  const formattedHeaders = [
    ...new Map(
      header.filter((h) => h !== "line_Id").map((h) => [h.toLowerCase(), h]) // use lowercase for key, original for value
    ).values(),
  ];

  const getPrintFieldValue = (row, pageName, field) => {
    console.log("row",row);
    
    const pageMap = {
      disassemblpage: {
        pur_Number: row.docNum,
        Actual_Weight: row.Weight,
      },
      productionfg: {
        pur_Number: row.order_Num,
        Actual_Weight: row.Weight,
      },
      Return: {
        pur_Number: row.delivery_Number,
        Actual_Weight: row.Weight,
      },
      default: {
        pur_Number: row.order_Num,
        Actual_Weight: row.actual_Gross_Wt || row.overall_Weight,
      },
    };

    return (pageMap[pageName] || pageMap.default)[field];
  };

  const handleActionClick = (action, rowIndex, row) => {
    if (action === "edit") {
      setOpenDropdownIndex(null);
      onEdit(action, rowIndex,row);
    } else if (action === "delete") {
      setOpenDropdownIndex(null);

      if (page && page === "GRPO") {
        showDeleteConfirmation(() => {
          const updatedTableBody = tablebody.filter(
            (_, index) => index !== rowIndex
          );
          setTableBody(updatedTableBody);
          setPrintedRows((prev) => {
            const updatedRows = [...prev];
            updatedRows.splice(rowIndex, 1); // ❗ Remove the same index
            return updatedRows;
          });
        });
      } else if (groupedDataSorted && groupedDataSorted.length > 0) {
        onDelete(action, rowIndex, row);
      } else {
        onDelete(action, rowIndex);
      }
    } else if (action === "Print") {
      // onPrint(action, rowIndex);
      const selectedRow = tablebody[rowIndex];
      console.log("selectedRow", selectedRow);

      const data = {
        // PageTitle: pageTitle,
        Order_Number: getPrintFieldValue(selectedRow, pageName, "pur_Number"),
        batch_Number: selectedRow.batch_Number,
        item_Code: selectedRow.item_Code,
        item_Name: selectedRow.item_Name,
        Actual_Weight: getPrintFieldValue(
          selectedRow,
          pageName,
          "Actual_Weight"
        ),
        ...(pageName === "Return" && { QtyNos: selectedRow.Quantity }),
        CreatedDate:
          pageName === "Return"
            ? dayjs().format("DD/MM/YYYY")
            : selectedRow.CreatedDate,
      };
      console.log("data", data);
      PrintLabel(data, rowIndex, "GRPO", "");
    }
  };

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            {(pageName === "disassemblpage" ||
              pageName === "productionfg" ||
              pageName === "GRPO" ||
              pageName === "Delivery") && (
              <>
                <th className="table-header sno-column sticky-col">
                  {t("S.No")}
                </th>
              </>
            )}
            {pageName !== "Disassemble" &&
              pageName !== "productionfg" &&
              pageName !== "GRPO" && (
                <th
                  className={`table-header ${
                    pageName === "disassemblpage"
                      ? " sticky-col sticky-col-2"
                      : "action-cell"
                  }`}
                >
                  {t("Action")}
                </th>
              )}
            {formattedHeaders.map((col, index) => (
              <th key={index} className="table-header">
                {t(convertCase(col))}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {/* ✅ Grouped Rendering */}
          {groupedDataSorted && groupedDataSorted.length > 0
            ? groupedDataSorted.map(([batch, rows], groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {/* Group Header Row */}
                  <tr className="group-header">
                    <td
                      colSpan={
                        header.length +
                        (pageName !== "Disassemble" &&
                        pageName !== "productionfg" &&
                        pageName !== "GRPO"
                          ? 2
                          : 1)
                      }
                    >
                      <strong>
                        {pageName === "Return"
                          ? `${t("Delivery Number")}: ${batch}`
                          : `${t("Item Code")}: ${batch}`}
                      </strong>
                    </td>
                  </tr>

                  {/* Grouped Rows */}
                  {rows.map((row, rowIndex) => {
                    const isDisabled = row.disabled;
                    return (
                      <tr
                        key={`${batch}-${rowIndex}`}
                        className={isDisabled ? "disabled-row" : ""}
                      >
                        {(pageName === "disassemblpage" ||
                          pageName === "productionfg" ||
                          pageName === "GRPO" ||
                          pageName === "Delivery") && (
                          <td className="sno-column sticky-col">
                            {rowIndex + 1}
                          </td>
                        )}

                        {pageName !== "Disassemble" &&
                          pageName !== "productionfg" &&
                          pageName !== "GRPO" && (
                            <td
                              className={
                                pageName === "disassemblpage"
                                  ? "sticky-col sticky-col-2"
                                  : "action-cell"
                              }
                            >
                              <button
                                className="actionBtn"
                                type="button"
                                onClick={() =>
                                  !isDisabled &&
                                  handleActionClick("edit", rowIndex, row)
                                }
                                disabled={isDisabled}
                              >
                                <ModeEditIcon />
                              </button>

                              {pageName !== "disassemblpage" && (
                                <button
                                  className="actionBtn"
                                  type="button"
                                  onClick={() =>
                                    !isDisabled &&
                                    handleActionClick("delete", rowIndex, row)
                                  }
                                  disabled={isDisabled}
                                >
                                  <DeleteIcon />
                                </button>
                              )}

                              {pageName !== "Disassemble" &&
                                pageName !== "disassemblpage" &&
                                pageName !== "InventoryTransfer" &&
                                pageName !== "Delivery" &&
                                pageName !== "productionfg" &&
                                pageName !== "GRPO" && (
                                  <button
                                    className="actionBtn"
                                    type="button"
                                    onClick={() =>
                                      !isDisabled &&
                                      handleActionClick("Print", rowIndex, row)
                                    }
                                    disabled={isDisabled}
                                  >
                                    <PrintIcon
                                      style={{
                                        backgroundColor: row.printed
                                          ? "green"
                                          : "",
                                      }}
                                    />
                                  </button>
                                )}
                            </td>
                          )}

                        {/* {header.map((col, colIndex) => (
                        <td key={colIndex}>{row[col]}</td>
                      ))} */}
                        {header.map((col, colIndex) => (
                          <td key={colIndex}>
                            {Array.isArray(row[col])
                              ? row[col].map((item) => item.label).join(", ")
                              : row[col]}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </React.Fragment>
              ))
            : // Fallback: Non-grouped rendering
              tablebody &&
              tablebody.map((row, rowIndex) => {
                const isDisabled = row.disabled;
                return (
                  <tr
                    key={rowIndex}
                    className={isDisabled ? "disabled-row" : ""}
                  >
                    {(pageName === "disassemblpage" ||
                      pageName === "productionfg" ||
                      pageName === "GRPO" ||
                      pageName === "Delivery") && (
                      <td className="sno-column sticky-col">{rowIndex + 1}</td>
                    )}

                    {pageName !== "Disassemble" &&
                      pageName !== "productionfg" &&
                      pageName !== "GRPO" && (
                        <td
                          className={
                            pageName === "disassemblpage"
                              ? "sticky-col sticky-col-2"
                              : "action-cell"
                          }
                        >
                          <button
                            className="actionBtn"
                            type="button"
                            onClick={() =>
                              !isDisabled &&
                              handleActionClick("edit", rowIndex, row)
                            }
                            disabled={isDisabled}
                          >
                            <ModeEditIcon />
                          </button>

                          {pageName !== "disassemblpage" && (
                            <button
                              className="actionBtn"
                              type="button"
                              onClick={() =>
                                !isDisabled &&
                                handleActionClick("delete", rowIndex, row)
                              }
                              disabled={isDisabled}
                            >
                              <DeleteIcon />
                            </button>
                          )}

                          {pageName !== "Disassemble" &&
                            pageName !== "disassemblpage" &&
                            pageName !== "InventoryTransfer" &&
                            pageName !== "Delivery" &&
                            pageName !== "productionfg" &&
                            pageName !== "GRPO" && (
                              <button
                                className="actionBtn"
                                type="button"
                                onClick={() =>
                                  !isDisabled &&
                                  handleActionClick("Print", rowIndex, row)
                                }
                                disabled={isDisabled}
                              >
                                <PrintIcon
                                  style={{
                                    backgroundColor: row.printed ? "green" : "",
                                  }}
                                />
                              </button>
                            )}
                        </td>
                      )}

                    {/* {header.map((col, colIndex) => (
                    <td key={colIndex}>{row[col]}</td>
                  ))} */}
                    {header.map((col, colIndex) => (
                      <td key={colIndex}>
                        {Array.isArray(row[col])
                          ? row[col].map((item) => item.label).join(", ")
                          : row[col]}
                      </td>
                    ))}
                  </tr>
                );
              })}
        </tbody>
      </table>
    </div>
  );
};
export default DynamicTable;

//   return (
//     <div className="table-responsive">
//       <table className="table table-bordered">
//         <thead>
//           <tr>
//             {(pageName === 'disassemblpage' || pageName==='productionfg' || pageName ==='GRPO' || pageName === 'Delivery')&&  (
//               <>
//                 <th className="table-header sno-column sticky-col">{t('S.No')}</th>
//               </>
//             )}
//             {pageName !== 'Disassemble' &&pageName!=='productionfg' &&pageName!=='GRPO' &&
//              <th className={`table-header ${pageName === 'disassemblpage' ? ' sticky-col sticky-col-2' : 'action-cell'}`}>{t('Action')}</th>}
//             {formattedHeaders.map((col, index) => (
//               <th key={index} className="table-header">
//                 {t(convertCase(col))}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {tablebody &&
//             tablebody.map((row, rowIndex) => {
//               const isDisabled = row.disabled; // 👈 check disabled flag
//               return (
//                 <tr key={rowIndex} className={isDisabled ? 'disabled-row' : ''}>
//                   {(pageName === 'disassemblpage' || pageName==='productionfg' || pageName ==='GRPO'|| pageName === 'Delivery')&& (
//                     <td className='sno-column sticky-col'>{rowIndex + 1}</td>
//                   )}

//                   {pageName !== 'Disassemble'&&pageName!=='productionfg' &&pageName!=='GRPO' &&  (
//                     <td className={pageName === 'disassemblpage' ? 'sticky-col sticky-col-2' : 'action-cell'}>
//                       {/* Disable interaction if the row is marked as disabled */}
//                       <button
//                         className="actionBtn"
//                         type="button"
//                         onClick={() => !isDisabled && handleActionClick('edit', rowIndex)}
//                         disabled={isDisabled}
//                       >
//                         <ModeEditIcon />
//                       </button>
//                       {pageName !== 'disassemblpage'&&pageName!=='productionfg' &&pageName!=='GRPO' && (
//                         <button
//                           className="actionBtn"
//                           type="button"
//                           onClick={() => !isDisabled && handleActionClick('delete', rowIndex)}
//                           disabled={isDisabled}
//                         >
//                           <DeleteIcon />
//                         </button>
//                       )}
//                       {pageName !== 'Disassemble' &&
//                         pageName !== 'disassemblpage' &&
//                         pageName !== 'InventoryTransfer' &&
//                         pageName !== 'Delivery' &&
//                         pageName!=='productionfg'&&
//                         pageName!=='GRPO' &&
//                          (
//                           <button
//                             className="actionBtn"
//                             type="button"
//                             onClick={() => !isDisabled && handleActionClick('Print', rowIndex)}
//                             disabled={isDisabled}
//                           >
//                             <PrintIcon
//                               style={{
//                                 backgroundColor:
//                                   printedRowss && printedRowss[rowIndex] ? 'green' : '',
//                               }}
//                             />
//                           </button>
//                         )}
//                     </td>
//                   )}

//                   {formattedHeaders.map((col, colIndex) => (
//                     <td key={colIndex}>{row[col]}</td>
//                   ))}
//                 </tr>
//               );
//             })}
//         </tbody>

//         {/* <tbody>
//           {tablebody &&
//             tablebody
//               // .filter(header => header !== 'Line Id')
//               .map((row, rowIndex) => (
//                 <tr key={rowIndex}>
//                   {pageName === 'disassemblpage' && (
//                     <>
//                       <td className='sno-column sticky-col'>{rowIndex + 1}</td>
//                     </>)}
//                   {pageName !== 'Disassemble' && (
//                     <td className={pageName === 'disassemblpage' ? 'sticky-col sticky-col-2' : 'action-cell'}>

//                       <button
//                         className="actionBtn"
//                         type="button"
//                         onClick={() => handleActionClick('edit', rowIndex)}
//                       >
//                         <ModeEditIcon />
//                       </button>
//                       {pageName !== 'disassemblpage' &&
//                         <button
//                           className="actionBtn"
//                           type="button"
//                           onClick={() => handleActionClick('delete', rowIndex)}
//                         >
//                           <DeleteIcon />
//                         </button>}
//                       {pageName !== 'Disassemble' &&
//                         pageName !== 'disassemblpage' &&
//                         pageName !== 'InventoryTransfer' &&
//                         pageName !== 'Delivery' && (
//                           <button
//                             className="actionBtn"
//                             type="button"
//                             onClick={() => handleActionClick('Print', rowIndex)}
//                           >
//                             <PrintIcon
//                               style={{
//                                 backgroundColor:
//                                   printedRowss && printedRowss[rowIndex] ? 'green' : '',
//                               }}
//                             />
//                           </button>
//                         )}
//                     </td>
//                   )}
//                   {formattedHeaders.map((col, colIndex) => {
//                     const value = row[col];
//                     return <td key={colIndex}>{value}</td>;
//                   })}

//                 </tr>
//               ))}
//         </tbody> */}
//       </table>
//     </div>
//   );
// };
// export default DynamicTable;
